import FormStateParams from "../interfaces/FormStateParams";

function GetFormJson(routeParams: FormStateParams) {
  const rp: FormStateParams = routeParams;
  if (rp == null || rp.webContentId === undefined) {
    return null;
  }

  let url = `${process.env.REACT_APP_API_URL}/api/newformeditor/${rp.webContentId}?`;
  url += new URLSearchParams({
    accountKey: rp.accountKey,
    sessionId: rp.sessionId,
    userlcid: rp.userlcid,
    orgname: rp.orgname,
    userid: rp.userid,
  });

  return fetch(url, {
    credentials: "include",
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw new Error(response.statusText);
  });
}

export default GetFormJson;
